/* eslint-disable react-refresh/only-export-components */
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';

import { cn } from '@/shared/components/shadcn/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1.5 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:shadow-glow aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary-hover',
        brand:
          'border-primary/20 bg-primary/10 text-primary dark:bg-primary/15',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90',
        destructive:
          'border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 dark:bg-destructive/60',
        outline:
          'text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
        success:
          'border-success/20 bg-success/10 text-success dark:bg-success/15',
        info: 'border-info/20 bg-info/10 text-info dark:bg-info/15',
        error: 'border-error/20 bg-error/10 text-error dark:bg-error/15',
        warning:
          'border-warning/25 bg-warning/10 text-warning dark:bg-warning/15',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const dotColor = {
  success: 'bg-success',
  info: 'bg-info',
  error: 'bg-error',
  warning: 'bg-warning',
  brand: 'bg-primary',
  default: 'bg-primary-foreground',
};

function Badge({ className, variant, asChild = false, dot = false, children, ...props }) {
  const Comp = asChild ? Slot : 'span';

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    >
      {dot && !asChild && (
        <span
          className={cn(
            'size-1.5 shrink-0 rounded-full',
            dotColor[variant] || dotColor.default,
          )}
        />
      )}
      {children}
    </Comp>
  );
}

export { Badge, badgeVariants };
